import type { RootState } from "../store"

export const payerMappingsSelector = (state: RootState) => state.payerMappings
